<div class="loader" *ngIf="isLoading" id="loader">
  <div class="loaderImg"><img src="./assets/images/loading.gif" alt="" /></div>
</div>
<div class="state_location_wrapper">

  <!--    <div class="state_location_hero">-->

  <div class="position-relative">
    <div class="state_page_banner videoBannerGlobal" *ngIf="result?.name">
      <video #videoElement width="100%" id="main-video" class="video-playing embed-responsive-item" loop muted autoplay
        playsinline oncanplay="this.play()" onloadedmetadata="this.muted = true" [poster]="image_url+result.image">
        <source id="source_mp4" [src]="image_url+result.video" type="video/mp4" *ngIf="result.video != null">
      </video>
      <!-- <img [src]="(result?.image) ? image_url+result?.image : '../../../assets/images/banner_opt_img.png'" alt=""> -->

      <div class="container ">
        <div class="state_locationhero_name siteBannerTitleLoc_cate">{{ result?.name }}</div>
      </div>
    </div>
    <div class="state_locationhero_text">
      <div class="state_locationhero_bar">
        <div class="container" *ngIf="bannerDisplayData && bannerDisplayDataLenth>0">
          <div class="state_locationhero_item">
            <span class="state_locationhero_itemhead font-17">{{ bannerDisplayData?.banner_display_title_1_up |
              appendDollar }}</span>
            <span class="state_locationhero_itemtext font-17">{{ bannerDisplayData?.banner_display_title_1_bottom |
              appendDollar }}</span>
          </div>
          <div class="state_locationhero_item">
            <span class="state_locationhero_itemhead font-17">{{ bannerDisplayData?.banner_display_title_2_up |
              appendDollar }}</span>
            <span class="state_locationhero_itemtext font-17">{{ bannerDisplayData?.banner_display_title_2_bottom |
              appendDollar }}</span>
          </div>
          <div class="state_locationhero_item">
            <span class="state_locationhero_itemhead font-17">{{ bannerDisplayData?.banner_display_title_3_up |
              appendDollar }}</span>
            <span class="state_locationhero_itemtext font-17">{{ bannerDisplayData?.banner_display_title_3_bottom |
              appendDollar }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container" *ngIf="result && foundResultData == true">
    <div class="bread-crumbs">
      <div class="">
        <a [routerLink]="['/']">{{"Home"}}</a> &gt;
      </div>
      <div class=""
        *ngIf="result.super_parent_location_slug != '' && result.super_parent_location_slug != null && result.super_parent_location_name != '' && result.super_parent_location_name != null">
        <a
          [routerLink]="['/location-region',result.super_parent_location_slug]">{{result.super_parent_location_name}}</a>
        &gt;
      </div>
      <div class=""
        *ngIf="result.parent_location_slug != '' && result.parent_location_slug != null && result.parent_location_name != '' && result.parent_location_name != null">
        <a [routerLink]="['/location-region',result.parent_location_slug]">{{result.parent_location_name |
          titlecase}}</a> &gt;
      </div>
      <div class="">
        <a [routerLink]="['/location-region',locationSlug,categorySlug]">{{result.name | titlecase}}</a>
      </div>
    </div>
  </div>
  <div id="midleHeight">
    <div class="container">
      <div class="map-desc-wrap" *ngIf="result && foundResultData == true">
        <div class="row">
          <div class="col-md-4">
            <div class="map-desc-wall" *ngIf="result.map_image">
              <img class="lazyload" [attr.data-src]="image_url+result?.map_image"
                src="../../../../assets/images/loading.gif" alt="">
            </div>
          </div>
          <div class="col-md-8">
            <div class="map-desc">
              <p [innerHTML]="result?.description"></p>
            </div>
          </div>
        </div>
      </div>


      <div class="statelower_content_wrap" *ngIf="isMobile">
        <div class="accordion" id="accordion">
          <div class="overView_collapse" *ngIf="featuresList?.length > 0">
            <a href="javascript:void(0);" data-toggle="collapse" data-target="#overview"
              class="overView_col_header btn-link collapsed">REASON TO VISIT</a>
            <div class="collapse" id="overview" data-parent="#accordion">
              <div class="accordion_inner">
                <ul class="list-unstyled">
                  <li *ngFor="let data of featuresList">
                    <div class="statelist-item-inner">
                      <div class="statelist-item-wall lazyload" [attr.data-bg]="image_url+data.image"
                        style="background-image:url('../../../../assets/images/loading.gif')">

                      </div>
                      <div class=" map-desc">
                        <span class="statelist-item-content">
                          <h3 class="">{{data.name}}</h3>
                        </span>
                        <p [innerHTML]="data.description | appendDollar"></p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

          </div>
          <div class="overView_collapse" *ngIf="weatherFeaturesList?.length > 0">
            <a href="javascript:void(0);" data-toggle="collapse" data-target="#details"
              class="overView_col_header btn-link collapsed">THE SEASONS</a>
            <div class="collapse" id="details" data-parent="#accordion">
              <div class="accordion_inner">
                <ul class="list-unstyled">
                  <li *ngFor="let data of weatherFeaturesList">
                    <div class="state_weather_inner">
                      <div class="state_weather_icon">
                        <img class="lazyload" [attr.data-src]="image_url+data.image" src="assets/images/loading.gif"
                          alt="">
                      </div>
                      <div class="">
                        <p [innerHTML]="data.description | appendDollar" class="font-17"></p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="statelower_content_wrap" *ngIf="!isMobile">
        <div class="row">
          <div class="col-md-7">
            <div class="statelist-item">
              <ul class="list-unstyled" *ngIf="featuresList?.length > 0">
                <li *ngFor="let data of featuresList">
                  <div class="statelist-item-inner">
                    <div class="statelist-item-wall lazyload" [attr.data-bg]="image_url+data.image"
                      style="background-image:url('../../../../assets/images/loading.gif')">

                    </div>
                    <div class=" map-desc">
                      <span class="statelist-item-content">
                        <h3 class="">{{data.name}}</h3>
                      </span>
                      <p [innerHTML]="data.description | appendDollar"></p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-5">
            <div class="state_weather_aspects" *ngIf="weatherFeaturesList?.length > 0">
              <div class="state_weather_aspects_head">THE SEASONS</div>
              <ul class="list-unstyled">
                <li *ngFor="let data of weatherFeaturesList">
                  <div class="state_weather_inner">
                    <div class="state_weather_icon">
                      <img class="lazyload" [attr.data-src]="image_url+data.image" src="assets/images/loading.gif"
                        alt="">
                    </div>
                    <div class="">
                      <p [innerHTML]="data.description | appendDollar" class="font-17"></p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="expsearch_wrap">
      <div class="container">
        <div class="exp_list_heading">
          <div class="search-list-box">
            <div class="expsearch-head">
              SPUR EXPERIENCES IN {{ result?.name | uppercase }}
            </div>
            <div class="form-group category_name position-relative">
              <p-autoComplete [virtualScroll]="true" [suggestions]="filteredGroups" [virtualScrollItemSize]="34"
                [group]="true" (onKeyUp)="onEnter($event)" (completeMethod)="onFiltering($event)"
                (onSelect)="onChangeSearch($event)" (onClear)="onChangeSearch($event)" field="value"
                placeholder="Find by Name/Category" [style]="{'width':'340px','text-align':'start'}"
                [inputStyle]="{'height':'37px', 'width':'100%'}">
                <ng-template let-group pTemplate="group">
                  <div class="flex align-items-start">
                    <span>{{ group.label }}</span>
                  </div>
                </ng-template>
              </p-autoComplete>
              <span class="right_searchIcon">
                <svg width="19" height="19" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M14.9536 14.9458L21 21M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z"
                    stroke="#555" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </span>
            </div>
          </div>
        </div>
        <div class=" no-gutters exps-tab">

          <div class="tabs-block">
            <div>
              <a class="exp-tabs-item" [ngClass]="(is_booking==0) ? 'active' : ' '" (click)="tab_change(0)"
                href="javascript:void(0);">Buy as Voucher</a>
            </div>
            <div>
              <a class="exp-tabs-item" [ngClass]="(is_booking==1) ? 'active' : ' '" href="javascript:void(0)"
                (click)="tab_change(1)">Instant Book a Day/Time</a>
            </div>
            <div>
              <a class="exp-tabs-item" [ngClass]="(is_booking==2) ? 'active' : ' '" href="javascript:void(0)"
                (click)="tab_change(2)">Event Tickets</a>
            </div>
          </div>
          <div class="view-map text-center col-12" *ngIf="enable_rfp_225">
            <div class="viewCustomCheck">

              <label for="viewMap"> View on map</label>
              <input type="checkbox" id="viewMap" [checked]="view_on_map" (click)="map_view($event)" hidden />
              <label for="viewMap" class="customCheckLable"><i class="fa fa-check"></i></label>
            </div>
          </div>
        </div>
        <!-- server -->
        <div class="container" *ngIf="is_booking==1 || is_booking==2">
          <div class="row">
            <div class="col-12">
              <div class="exp_tab_New">
                <div class="exp_Calendar_new">
                  <i class="far fa-calendar searchBtn"></i>
                  <input type="text" bsDaterangepicker placeholder="" [dateCustomClasses]="dateCustomClasses"
                    placement="bottom left" class="date-picker"
                    [bsConfig]="{showWeekNumbers:false, dateInputFormat: 'MM/DD/YYYY',displayMonths :1}"
                    [minDate]="minDate" [maxDate]="maxDate" [minDate]="minDate" placeholder="Select dates"
                    [(ngModel)]="selectedDateRange" [ngModelOptions]="{standalone: true}"
                    (bsValueChange)="onSchedulingDateSelect($event)" readonly="readonly"
                    (onShown)="onShowPicker($event)" />
                  <a class="dataClear" (click)="clearDate()"
                    *ngIf="start_date  && start_date != '' && end_date && end_date != '' " href="javascript:void(0);">
                    <svg width="10" height="10" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M3.8125 3.81227C4.04691 3.57793 4.36479 3.44629 4.69625 3.44629C5.02771 3.44629 5.34559 3.57793 5.58 3.81227L10 8.23227L14.42 3.81227C14.6558 3.58457 14.9715 3.45858 15.2993 3.46143C15.627 3.46428 15.9405 3.59574 16.1723 3.8275C16.404 4.05926 16.5355 4.37277 16.5383 4.70052C16.5412 5.02827 16.4152 5.34402 16.1875 5.57977L11.7675 9.99977L16.1875 14.4198C16.4152 14.6555 16.5412 14.9713 16.5383 15.299C16.5355 15.6268 16.404 15.9403 16.1723 16.172C15.9405 16.4038 15.627 16.5353 15.2993 16.5381C14.9715 16.541 14.6558 16.415 14.42 16.1873L10 11.7673L5.58 16.1873C5.34425 16.415 5.02849 16.541 4.70075 16.5381C4.373 16.5353 4.05949 16.4038 3.82773 16.172C3.59597 15.9403 3.46451 15.6268 3.46166 15.299C3.45881 14.9713 3.5848 14.6555 3.8125 14.4198L8.2325 9.99977L3.8125 5.57977C3.57816 5.34536 3.44652 5.02748 3.44652 4.69602C3.44652 4.36457 3.57816 4.04668 3.8125 3.81227Z"
                        fill="#25324B" />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ng-container *ngIf="is_booking != 2; else ticketEventBlock">
          <div class="SelectExpCoupleBody pt-0" *ngIf="view_on_map==false">

            <ul class="products-list">
              
              @if (gridView === false) {
                <div class="container">
                  <img class="mobile-view" src="./assets/images/grid_view.svg" alt="grid" (click)="changeView()" />
                </div>
                <li class="products fullWidth-cardBox" *ngIf="certificate_data && is_booking==0">
                  <a href="javascript:void(0);">
                    <!-- please make sure that Image Should be 340X332 -->
                    <div class="product-image lazyload"
                      [attr.data-bg]="certificate_data.image_url ? certificate_data.image_url+'?height=600' : '../../../../assets/images/gift-exp.png'"
                      style="background-image:url('../../../../assets/images/loading.gif');">
                    </div>
                    <div class="product-info">
                      <div class="product-name">
                        <h2>
                          {{certificate_data.title}}
                          <span class="city_em"></span>
                        </h2>
                      </div>
                    </div>
                    <div class="rateHome">
                      ANY AMOUNT
                    </div>
                  </a>
                  <div class="addcart_btn" *ngIf="isBrowser">
                    <a href="javascript:void(0);" (click)="add_gift_certificate()">add to cart</a>
                  </div>
                </li>
                <li #allExperiences [id]="i" class="products fullWidth-cardBox position-relative fullWidth-cardBox"
                  *ngFor="let record of resultExp; let i = index">
                  <div class="position-relative">
                    <div
                      *ngIf="!isUserLogin && record.child_experiences && record.child_experiences.length == 0 && record.experience_type != 2 && record.instant_book==0"
                      id="select_people_{{i}}" class="interCard select_people">
                      <h4 class="modal-headerTitle">Select People</h4>
                      <div class="cartpopup_removecart closeBtn" (click)="removeClass(i,'select_people_')">×</div>
  
                      <div class="person_count" *ngFor="let data of record?.book_quantity_options"
                        (click)="openDialog(record,record.exp_price,'buy-for-yourself', record.sales_tax,data);removeClass(i,'select_people_')">
                        For {{data?.qty}} {{ data?.value }}
                        <ng-container *ngIf="record?.alternate_quantity == 0">
                          ${{record.exp_price*data?.key}}
                        </ng-container>
                      </div>
                    </div>
                    <div class="exp_add_remove_click"
                      *ngIf="isUserLogin && (record.experience_status <= 1) && record.child_experiences?.length == 0 && (authUser.role_id == 1 || authUser.role_id == 4 || authUser.role_id == 5)">
                      <div class="mobileAddRegistryImg"
                        *ngIf="record.experience_type <= 2 && (record.is_registry_status == 0)"
                        (click)="addToRegistry(record.id,'experiences_class_for_couple', i)">
                        <img src="../../../../assets/images/exp_add_image.png" class="">
                      </div>
  
                      <div class="mobileRemoveRegistryImg"
                        *ngIf="record.experience_type <= 2 && record.is_registry_status == 1"
                        (click)="addToRegistry(record.id,'experiences_class_for_couple', i)">
                        <img src="../../../../assets/images/exp_remove_image.png" class="">
                      </div>
                    </div>
                    <a href="javascript:void(0);" *ngIf="isUserLogin ; else elseblock"
                      routerLink="/experiences/{{record.slug}}" (click)="exp_detail($event,record.slug,i)">
  
                      <div *ngIf="record?.cover_video != ''; else imageBlock">
  
  
                        <div class="video-block">
                          <video *ngIf="record?.cover_video != null" #videoElement width="100%" id="exp-video"
                            class="video-playing embed-responsive-item" loop muted playsinline
                            onloadedmetadata="this.muted = true" [poster]="record?.image_url">
                            <source [src]="record?.cover_video" type="video/mp4" />
                          </video>
                          
                          <div class="lazyload">
                            <div class="add_registry_checkmark active" *ngIf="record.is_show_ckbx == 1 && isUserLogin">
                            </div>
  
                            <h4 class="received_viewCount" [ngClass]="record.add_reg_msg_class"
                              *ngIf="record.child_experiences?.length == 0 && record.experience_status_msg != ''">
                              {{record.experience_status_msg}}
                            </h4>
                          </div>
                        </div>
  
  
                      </div>
                      <ng-template #imageBlock>
                        <div *ngIf="record.child_experiences?.length == 0 ; else elseblock1"
                          class="product-image lazyload"
                          [attr.data-bg]="(record.image == '') ? 'assets/images/vebo_find_img.png' : record.image_url+'?height=600'"
                          style="background-image:url(assets/images/loading.gif)">
                          <div class="add_registry_checkmark active" *ngIf="record.is_show_ckbx == 1 && isUserLogin">
                          </div>
  
                          <h4 class="received_viewCount" [ngClass]="record.add_reg_msg_class"
                            *ngIf="record.child_experiences?.length == 0 && record.experience_status_msg != ''">
                            {{record.experience_status_msg}}
                          </h4>
                        </div>
                      </ng-template>
  
                      <ng-template #elseblock1>
                        <div routerLink="/experiences/{{record.slug}}" (click)="exp_detail($event,record.slug,i)"
                          class="product-image lazyload"
                          [attr.data-bg]="(record.image == '') ? 'assets/images/vebo_find_img.png' : record.image_url+'?height=600'"
                          style="background-image:url(assets/images/loading.gif)">
                        </div>
                      </ng-template>
                      <div class="product-info" routerLink="/experiences/{{record.slug}}"
                        (click)="exp_detail($event,record.slug,i)">
                        <div class="product-name">
                          <h2>
                            {{ record.title }}
                            <span class="city_em" *ngIf="record?.city && record.city !== '' ">{{record.city ? record.city : ''}}</span>
                          </h2>
                        </div>
                      </div>
                    </a>
                    <div class="product-hover hover-regist"
                      *ngIf="isUserLogin && (record.experience_status <= 1) && record.child_experiences?.length == 0 && (authUser.role_id == 1 || authUser.role_id == 4 || authUser.role_id == 5)">
  
                      <a [ngClass]="record.added_registry_type == 'experiences_join_us' ? 'buyforquick' : 'removeexpcouplequick'"
                        href="javascript:void(0);" *ngIf="record.experience_type <= 2 && record.is_registry_status == 1"
                        (click)="addToRegistry(record.id,'experiences_class_for_couple', i)">
                        {{authUser.role_id == 4 || authUser.role_id == 5 ? 'Remove from Bucket List' : 'Remove from
                        registry'}}
                      </a>
  
                      <a class="removeexpcouplequick" href="javascript:void(0);"
                        *ngIf="record.experience_type <= 2 && (record.is_registry_status == 0)"
                        (click)="addToRegistry(record.id,'experiences_class_for_couple', i)">{{authUser.role_id == 4 ||
                        authUser.role_id == 5 ? 'Add to Bucket List' : 'Add to registry'}}</a>
  
                    </div>
                    <ng-template #elseblock>
  
                      <a href="javascript:void(0);" routerLink="/experiences/{{record.slug}}"
                        (click)="exp_detail($event,record.slug,i)">
  
                        <div *ngIf="record?.cover_video != ''; else imageBlock1">
                          <div class="video-block">
                            <video *ngIf="record?.cover_video != null" #videoElement width="100%" id="exp-video"
                              class="video-playing embed-responsive-item" loop muted playsinline
                              onloadedmetadata="this.muted = true" [poster]="record?.image_url">
                              <source [src]="record?.cover_video" type="video/mp4" />
                            </video>
                          </div>
  
                        </div>
                        <ng-template #imageBlock1>
                          <div class="product-image lazyload"
                            [attr.data-bg]="(record.image == '') ? 'assets/images/vebo_find_img.png' : record.image_url+'?height=600'"
                            style="background-image:url(assets/images/loading.gif)">
                          </div>
                        </ng-template>
  
                        <div class="product-info">
                          <div class="product-name d-block">
                            <h2>
                              {{ record.title }}
                              <span class="city_em" *ngIf="record?.city && record.city !== '' ">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                  xmlns="http://www.w3.org/2000/svg">
                                  <path
                                    d="M8 14.5C10.5 11 12.5 8 12.5 6C12.5 4.80653 12.0259 3.66193 11.182 2.81802C10.3381 1.97411 9.19347 1.5 8 1.5C6.80653 1.5 5.66193 1.97411 4.81802 2.81802C3.97411 3.66193 3.5 4.80653 3.5 6C3.5 8 5.5 11 8 14.5Z"
                                    stroke="#e85325"></path>
                                  <path
                                    d="M10 6C10 6.53043 9.78929 7.03914 9.41421 7.41421C9.03914 7.78929 8.53043 8 8 8C7.46957 8 6.96086 7.78929 6.58579 7.41421C6.21071 7.03914 6 6.53043 6 6C6 5.46957 6.21071 4.96086 6.58579 4.58579C6.96086 4.21071 7.46957 4 8 4C8.53043 4 9.03914 4.21071 9.41421 4.58579C9.78929 4.96086 10 5.46957 10 6Z"
                                    stroke="#e85325"></path>
                                </svg>
                                {{record.city ? record.city : ''}}
                              </span>
                            </h2>
                          </div>
                        </div>
                      </a>
                    </ng-template>
  
                    <div class="rateHome" *ngIf="record.experience_type == 1">
                      ${{record.exp_price && record.exp_price>0 ? (record.exp_price | priceFormat) : '00'}}
                      <span> &#123; {{record.price_label}} &#125;</span>
                    </div>
                    <div class="rateHome" *ngIf="record.experience_type == 7">
                      @if(record?.exp_price > 0) {
                        ${{ record.exp_price }} <span> &#123; {{record.price_label}}  &#125;</span>
                      } @else if (record?.regular_price > 0 || record?.regular_price !== '') {
                        ${{ record.regular_price }} <span> &#123; {{record.price_label}}  &#125;</span>
                      } @else {
                        ${{ (record.exp_price == '') ? 0 : record.exp_price }} <span> &#123; {{record.price_label}}  &#125;</span>
                      }
                    </div>
  
                    <div class="rateHome" *ngIf="record.experience_type == 2">
                      ANY PRICE
                    </div>
  
                    <div *ngIf="record.child_experiences?.length > 0 && isBrowser">
                      <button class="viewOptionbtn" (click)="exp_detail($event,record.slug,i)">VIEW PRICING OPTION</button>
                    </div>

                    <div *ngIf="record?.review_rating > 0">
                      <p-rating [(ngModel)]="record.review_rating" [readonly]="true"  [stars]="5"  [cancel]="false">
                        <ng-template pTemplate="onicon">
                          <i class="pi pi-star-fill" style="color: #e85325"></i>
                        </ng-template>
                        <ng-template pTemplate="officon">
                          <i class="pi pi-star" style="color: #e85325"></i>
                        </ng-template>
                        </p-rating>
                        <span class="rating-info">
                          ( {{record.review_rating}} 
                          <span class="vertical-separator"></span>
                          {{record.reviews_count}} {{record.reviews_count === 1 ? 'Review' : 'Reviews'}} )
                        </span>
                     </div>

                    <div class="addcart_btn" *ngIf="isBrowser">
                      @if(is_booking !== 1 && (!record?.for_individual_price || record?.for_individual_price == 0) && 
                      !isUserLogin && record.child_experiences && record.child_experiences.length == 0 && record.experience_type != 2 && record.instant_book==0 && isBrowser) {
                        <a href="javascript:void(0)"
                        (click)="openDialog(record,record.exp_price,'buy-for-yourself', record.sales_tax,2)">ADD TO CART</a>
                      } @else if(is_booking !== 1 && record?.for_individual_price > 0 && !isUserLogin && 
                      record.child_experiences && record.child_experiences.length == 0 && record.experience_type != 2 &&
                       record.instant_book == 0) {
                        <a href="javascript:void(0)" (click)="addCartQuantity(i,record,'select_people_')">ADD TO CART</a>
                      } @else if(is_booking !== 1 && record.experience_type == 2) {
                        <a href="javascript:void(0);" (click)="add_gift_event(record)">add to cart</a>
                      } @else {
                        <a href="javascript:void(0)" routerLink="/experiences/{{record.slug}}"
                        *ngIf="!isUserLogin && record?.child_experiences && record?.child_experiences?.length == 0 &&
                        record?.experience_type != 2 && record?.instant_book==1"
                        (click)="exp_detail($event,record.slug,i,'book_now')">see availability</a>
                      }                  
                    </div>
                    <!-- <div class="startingPrice" *ngIf="record.instant_book==1">
                      <svg x="0px" y="0px" viewBox="0 0 27.793 27.793" style="height:18px; fill:#666;">
                        <polygon
                          points="20.972,0 5.076,15.803 10.972,15.803 6.44,27.793 22.716,11.989 16.819,11.989   " />
                      </svg> Instant Book
                    </div> -->
                  </div>
                </li>

              } @else if (gridView === true) {
              <div class="container">
                <img class="mobile-view" src="./assets/images/list_view.svg" alt="list" (click)="changeView()" />
              </div>
              <li class="products" *ngIf="certificate_data && is_booking==0">
                <a href="javascript:void(0);">
                  <!-- please make sure that Image Should be 340X332 -->
                  <div class="product-image lazyload"
                    [attr.data-bg]="certificate_data.image_url ? certificate_data.image_url+'?height=600' : '../../../../assets/images/gift-exp.png'"
                    style="background-image:url('../../../../assets/images/loading.gif');">
                  </div>
                  <div class="product-info">
                    <div class="product-name">
                      <h2>
                        {{certificate_data.title}}
                        <span class="city_em"></span>
                      </h2>
                    </div>
                  </div>
                  <div class="rateHome">
                    ANY AMOUNT
                  </div>
                </a>
                <div class="addcart_btn" *ngIf="isBrowser">
                  <a href="javascript:void(0);" (click)="add_gift_certificate()">add to cart</a>
                </div>
              </li>

              <li #allExperiences [id]="i" class="products position-relative"
                *ngFor="let record of resultExp; let i = index">
                <div class="position-relative">
                  <div
                    *ngIf="!isUserLogin && record.child_experiences && record.child_experiences.length == 0 && record.experience_type != 2 && record.instant_book==0"
                    id="select_people_{{i}}" class="interCard select_people">
                    <h4 class="modal-headerTitle">Select People</h4>
                    <div class="cartpopup_removecart closeBtn" (click)="removeClass(i,'select_people_')">×</div>

                    <div class="person_count" *ngFor="let data of record?.book_quantity_options"
                      (click)="openDialog(record,record.exp_price,'buy-for-yourself', record.sales_tax,data);removeClass(i,'select_people_')">
                      For {{data?.qty}} {{ data?.value }}
                      <ng-container *ngIf="record?.alternate_quantity == 0">
                        ${{record.exp_price*data?.key}}
                      </ng-container>
                    </div>
                  </div>
                  <div class="exp_add_remove_click"
                    *ngIf="isUserLogin && (record.experience_status <= 1) && record.child_experiences?.length == 0 && (authUser.role_id == 1 || authUser.role_id == 4 || authUser.role_id == 5)">
                    <div class="mobileAddRegistryImg"
                      *ngIf="record.experience_type <= 2 && (record.is_registry_status == 0)"
                      (click)="addToRegistry(record.id,'experiences_class_for_couple', i)">
                      <img src="../../../../assets/images/exp_add_image.png" class="">
                    </div>

                    <div class="mobileRemoveRegistryImg"
                      *ngIf="record.experience_type <= 2 && record.is_registry_status == 1"
                      (click)="addToRegistry(record.id,'experiences_class_for_couple', i)">
                      <img src="../../../../assets/images/exp_remove_image.png" class="">
                    </div>
                  </div>
                  <a href="javascript:void(0);" *ngIf="isUserLogin ; else elseblock"
                    routerLink="/experiences/{{record.slug}}" (click)="exp_detail($event,record.slug,i)">

                    <div *ngIf="record.child_experiences?.length == 0 ; else elseblock1" class="product-image lazyload"
                      [attr.data-bg]="(record.image == '') ? 'assets/images/vebo_find_img.png' : record.image_url+'?height=600'"
                      style="background-image:url(assets/images/loading.gif)">
                      <div class="add_registry_checkmark active" *ngIf="record.is_show_ckbx == 1 && isUserLogin"></div>

                      <h4 class="received_viewCount" [ngClass]="record.add_reg_msg_class"
                        *ngIf="record.child_experiences?.length == 0 && record.experience_status_msg != ''">
                        {{record.experience_status_msg}}
                      </h4>

                    </div>

                    <ng-template #elseblock1>
                      <div routerLink="/experiences/{{record.slug}}" (click)="exp_detail($event,record.slug,i)"
                        class="product-image lazyload"
                        [attr.data-bg]="(record.image == '') ? 'assets/images/vebo_find_img.png' : record.image_url+'?height=600'"
                        style="background-image:url(assets/images/loading.gif)">
                      </div>
                    </ng-template>
                    <div class="product-info" routerLink="/experiences/{{record.slug}}"
                      (click)="exp_detail($event,record.slug,i)">
                      <div class="product-name d-block">
                        <h2>
                          {{ record.title }}

                        </h2>
                        <span class="city_em" *ngIf="record?.city && record.city !== '' ">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M8 14.5C10.5 11 12.5 8 12.5 6C12.5 4.80653 12.0259 3.66193 11.182 2.81802C10.3381 1.97411 9.19347 1.5 8 1.5C6.80653 1.5 5.66193 1.97411 4.81802 2.81802C3.97411 3.66193 3.5 4.80653 3.5 6C3.5 8 5.5 11 8 14.5Z"
                              stroke="#e85325"></path>
                            <path
                              d="M10 6C10 6.53043 9.78929 7.03914 9.41421 7.41421C9.03914 7.78929 8.53043 8 8 8C7.46957 8 6.96086 7.78929 6.58579 7.41421C6.21071 7.03914 6 6.53043 6 6C6 5.46957 6.21071 4.96086 6.58579 4.58579C6.96086 4.21071 7.46957 4 8 4C8.53043 4 9.03914 4.21071 9.41421 4.58579C9.78929 4.96086 10 5.46957 10 6Z"
                              stroke="#e85325"></path>
                          </svg>
                          {{record.city ? record.city : ''}}</span>
                      </div>
                    </div>
                  </a>
                  <div class="product-hover hover-regist"
                    *ngIf="isUserLogin && (record.experience_status <= 1) && record.child_experiences?.length == 0 && (authUser.role_id == 1 || authUser.role_id == 4 || authUser.role_id == 5)">

                    <a [ngClass]="record.added_registry_type == 'experiences_join_us' ? 'buyforquick' : 'removeexpcouplequick'"
                      href="javascript:void(0);" *ngIf="record.experience_type <= 2 && record.is_registry_status == 1"
                      (click)="addToRegistry(record.id,'experiences_class_for_couple', i)">
                      {{authUser.role_id == 4 || authUser.role_id == 5 ? 'Remove from Bucket List' : 'Remove from
                      registry'}}
                    </a>

                    <a class="removeexpcouplequick" href="javascript:void(0);"
                      *ngIf="record.experience_type <= 2 && (record.is_registry_status == 0)"
                      (click)="addToRegistry(record.id,'experiences_class_for_couple', i)">{{authUser.role_id == 4 ||
                      authUser.role_id == 5 ? 'Add to Bucket List' : 'Add to registry'}}</a>

                  </div>
                  <ng-template #elseblock>
                    <a href="javascript:void(0);" routerLink="/experiences/{{record.slug}}"
                      (click)="exp_detail($event,record.slug,i)">
                      <div class="product-image lazyload"
                        [attr.data-bg]="(record.image == '') ? 'assets/images/vebo_find_img.png' : record.image_url+'?height=600'"
                        style="background-image:url(assets/images/loading.gif)">
                      </div>
                      <div class="product-info">
                        <div class="product-name d-block">
                          <h2>
                            {{ record.title }}

                          </h2>
                          <span class="city_em" *ngIf="record?.city && record.city !== '' ">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M8 14.5C10.5 11 12.5 8 12.5 6C12.5 4.80653 12.0259 3.66193 11.182 2.81802C10.3381 1.97411 9.19347 1.5 8 1.5C6.80653 1.5 5.66193 1.97411 4.81802 2.81802C3.97411 3.66193 3.5 4.80653 3.5 6C3.5 8 5.5 11 8 14.5Z"
                                stroke="#e85325"></path>
                              <path
                                d="M10 6C10 6.53043 9.78929 7.03914 9.41421 7.41421C9.03914 7.78929 8.53043 8 8 8C7.46957 8 6.96086 7.78929 6.58579 7.41421C6.21071 7.03914 6 6.53043 6 6C6 5.46957 6.21071 4.96086 6.58579 4.58579C6.96086 4.21071 7.46957 4 8 4C8.53043 4 9.03914 4.21071 9.41421 4.58579C9.78929 4.96086 10 5.46957 10 6Z"
                                stroke="#e85325"></path>
                            </svg>
                            {{record.city ? record.city : ''}}</span>
                        </div>
                      </div>
                    </a>
                  </ng-template>

                  <div class="rateHome" *ngIf="record.experience_type == 1">
                    ${{record.exp_price && record.exp_price>0 ? (record.exp_price | priceFormat) : '00'}}
                    <span> &#123; {{record.price_label}} &#125;</span>
                  </div>
                  <div class="rateHome" *ngIf="record.experience_type == 7">
                    @if(record?.exp_price > 0) {
                      ${{ record.exp_price }} <span> &#123; {{record.price_label}}  &#125;</span>
                    } @else if (record?.regular_price > 0 || record?.regular_price !== '') {
                      ${{ record.regular_price }} <span> &#123; {{record.price_label}}  &#125;</span>
                    } @else {
                      ${{ (record.exp_price == '') ? 0 : record.exp_price }} <span> &#123; {{record.price_label}}  &#125;</span>
                    }
                  </div>

                  <div class="rateHome" *ngIf="record.experience_type == 2">
                    ANY PRICE
                  </div>

                  <div *ngIf="record.child_experiences?.length > 0 && isBrowser">
                    <button class="viewOptionbtn" (click)="exp_detail($event,record.slug,i)">VIEW PRICING
                      OPTION</button>
                  </div>
                  <div *ngIf="record.review_rating > 0">
                    <p-rating [(ngModel)]="record.review_rating" [readonly]="true"  [stars]="5"  [cancel]="false">
                      <ng-template pTemplate="onicon">
                        <i class="pi pi-star-fill" style="color: #e85325"></i>
                      </ng-template>
                      <ng-template pTemplate="officon">
                        <i class="pi pi-star" style="color: #e85325"></i>
                      </ng-template>
                      </p-rating>
                      <span class="rating-info">
                        ( {{record.review_rating}} 
                        <span class="vertical-separator"></span>
                        {{record.reviews_count}} {{record.reviews_count === 1 ? 'Review' : 'Reviews'}} )
                      </span>
                   </div>
                  <div class="addcart_btn">
                    @if(is_booking !== 1 && (!record?.for_individual_price || record?.for_individual_price == 0) && 
                      !isUserLogin && record.child_experiences && record.child_experiences.length == 0 && record.experience_type != 2 && record.instant_book==0 && isBrowser) {
                        <a href="javascript:void(0)"
                        (click)="openDialog(record,record.exp_price,'buy-for-yourself', record.sales_tax,2)">ADD TO CART</a>
                      } @else if(is_booking !== 1 && record?.for_individual_price > 0 && !isUserLogin && 
                      record.child_experiences && record.child_experiences.length == 0 && record.experience_type != 2 &&
                       record.instant_book == 0) {
                        <a href="javascript:void(0)" (click)="addCartQuantity(i,record,'select_people_')">ADD TO CART</a>
                      } @else if(is_booking !== 1 && record.experience_type == 2) {
                        <a href="javascript:void(0);" (click)="add_gift_event(record)">add to cart</a>
                      } @else {
                        <a href="javascript:void(0)" routerLink="/experiences/{{record.slug}}"
                        *ngIf="!isUserLogin && record.child_experiences && record.child_experiences.length == 0 &&
                        record.experience_type != 2 && record.instant_book==1"
                        (click)="exp_detail($event,record.slug,i,'book_now')">see availability</a>
                      }
                  </div>
                </div>
              </li>
              }


            </ul>
          </div>
        </ng-container>
        <ng-template #ticketEventBlock>
          <div class="eventList" *ngIf="!view_on_map && is_booking==2">
            <div class="container">
              <ng-container *ngIf="resultExp && resultExp.length > 0">
                <div class="row eventBlock_head align-items-center" *ngFor="let data of resultExp">
                  <div class="col-12 col-md-2 px-0">
                    <div class="eventDate">
                      <h5>{{data.day_name}}</h5>
                      <h6>{{data.event_date}}</h6>
                    </div>
                  </div>
                  <div class="col-12 col-md-8 text-center text-md-left px-0">
                    <div class="eventInfo">
                      <div><a [routerLink]="['/vebo-seats']"
                          [queryParams]="{'event_id': data.event_id}">{{data.event_name}}</a>
                      </div>
                      <span>{{data.event_time}} - {{data.venue_name}}, {{data.venue_location}}</span>
                    </div>
                  </div>
                  <div class="col-12 col-md-2 px-0 text-center text-md-right">
                    <div class="tkt_End">
                      <span>from</span>
                      <div class="tkt_end_day">
                        {{data.min_price!='$null' && data.min_price!='$0.00' ? data.min_price : 'NA' }} <span>(All-In
                          Price)</span>
                      </div>
                      <span>{{data.available_count}} tickets left</span>
                    </div>
                  </div>
                </div>
              </ng-container>
              <div class="empty_ticket_div" *ngIf="resultExp && resultExp?.length==0 && isDataLoading == false">
                <span>Oops!</span>
                <p>No results found</p>
              </div>
            </div>
          </div>
        </ng-template>
      </div>

    </div>
  </div>
  <div class="container-fluid" id="mapParent_2" [ngClass]="{'px-0' : view_on_map && is_booking == 2}">
    <div class="row" *ngIf="view_on_map && enable_rfp_225 && is_booking != 2">
      <div class="col-12 order-1 order-lg-0 col-lg-6 mapListBg">

        <ng-container *ngIf="resultExp && resultExp.length > 0">

          <div class="mapCard" (mouseenter)="map_image_enter(i)" (mouseleave)="map_image_out(i)"
            *ngFor="let record of resultExp | paginate: {itemsPerPage:pageSize,currentPage: page,totalItems: totalRecord } ,let i = index">
            <div class="mapCardimg lazyload"
              [attr.data-bg]="(record.image_url == '') ? 'assets/images/vebo_find_img.png' : record.image_url+'?height=600'"
              style="background-image:url('../../../../assets/images/loading.gif');">
              <a *ngIf="record.experience_status_msg != '' && isUserLogin" href="javascript:void(0);"
                (click)="exp_detail($event,record.slug,i)" [ngClass]="record.add_reg_msg_class">
                {{record.experience_status_msg}}
              </a>

              <div class="exp_add_remove_click"
                *ngIf="isUserLogin && record.experience_status <= 1 && record.child_experiences?.length == 0 && (authUser.role_id == 1 || authUser.role_id == 4 || authUser.role_id == 5)">
                <div class="mobileAddRegistryImg"
                  *ngIf="record.experience_type <= 2 && (record.is_registry_status == 0 || record.is_registry_status == 2)"
                  (click)="addToRegistry(record.id,'experiences_class_for_couple',i)">
                  <img src="assets/images/exp_add_image.png" class="">
                </div>
                <div class="mobileRemoveRegistryImg"
                  *ngIf="record.experience_type <= 2 && record.is_registry_status == 1"
                  (click)="addToRegistry(record.id,'experiences_class_for_couple',i)">
                  <img src="assets/images/exp_remove_image.png" class="">
                </div>
              </div>



            </div>
            <div class="mapCardcontnet map_btn position-relative">
              <div *ngIf="record.experience_type == 1" id="select_map_people_{{i}}" class="interCard select_map_people">
                <h4 class="modal-headerTitle">Select People</h4>
                <div class="cartpopup_removecart closeBtn" (click)="removeClass(i,'select_map_people_')">×</div>
                <div class="person_count"
                  (click)="openDialog(record,record.exp_price,'buy-for-yourself',record.sales_tax,data);removeClass(i,'select_map_people_')"
                  *ngFor="let data of record?.book_quantity_options">
                  For {{data?.qty}} {{ data?.value }}
                  <ng-container *ngIf="record?.alternate_quantity == 0">
                    ${{record.exp_price*data?.key}}
                  </ng-container>
                </div>
              </div>
              <div class="mapCardTitle"><a href="javascript:void(0);"
                  (click)="exp_detail($event,record.slug,i)">{{record.title}}</a></div>
              <div class="mapCompnyName">
                <!-- <div routerLink="/providers/{{record.provider_username}}">{{record?.company_name}}</div> -->
                <div>{{record?.company_name}}</div> <a *ngIf="1>2"
                  href="javascript:void(0);">{{record.company_website}}</a>
              </div>
              <div class="mapCompnyAddress"><i class="fas fa-map-marker-alt pr-1"></i> {{record.city}} {{record.state}}
              </div>
              <div *ngIf="!isUserLogin && record.experience_type == 2 && isBrowser">
                <button *ngIf="1>2" class="themeBtn">Buy as gift</button>
                <button class="themeBtn" [routerLink]="['/ticket-category']">Browse tickets</button>
                <button class="themeBtn" (click)="add_gift_event(record)">Add to cart</button>
              </div>
              <div
                *ngIf="isUserLogin && record.experience_status <= 1 && record.child_experiences?.length == 0 && (authUser.role_id == 1 || authUser.role_id == 4 || authUser.role_id == 5)">
                <button class="themeBtn" *ngIf="record.experience_type <= 2 && record.is_registry_status == 1"
                  (click)="addToRegistry(record.id,'experiences_class_for_couple',i)">{{authUser.role_id == 4 ||
                  authUser.role_id == 5 ? 'Remove from Bucket List' : 'Remove from registry'}}</button>

                <button class="themeBtn"
                  *ngIf="record.experience_type <= 2 && (record.is_registry_status == 0 || record.is_registry_status == 2)"
                  (click)="addToRegistry(record.id,'experiences_class_for_couple',i)">{{authUser.role_id == 4 ||
                  authUser.role_id == 5 ? 'Add to Bucket List' : 'Add to registry'}}</button>

                <!-- <button class="themeBtn" *ngIf="1>2 && record.experience_type == 1 && (record.is_registry_status == 0 || record.is_registry_status == 2) && record.additional_person_price > 0 && authUser.role_id ==1" (click)="addToRegistry(record.id,'experiences_join_us',i)">add with join us</button> -->
              </div>
              <button class="themeBtn"
                *ngIf="record.experience_type == 1 && (isUserLogin  || !record?.for_individual_price || record?.for_individual_price == 0)"
                (click)="openDialog(record,record.exp_price,'buy-for-yourself',record.sales_tax,2) && isBrowser">Add to
                cart</button>
              <button class="themeBtn" (click)="addCartQuantity(i,record,'select_map_people_')"
                *ngIf="!isUserLogin && record?.for_individual_price > 0 && record.experience_type == 1 && isBrowser">Add
                to
                cart</button>

              <button class="themeBtnRed" (click)="exp_detail($event,record.slug,i,'book_now')"
                *ngIf="record.instant_book==1">see availability</button>

              <!-- <div class="startingPrice" *ngIf="1>2 && record.instant_book==1">
                <svg x="0px" y="0px" viewBox="0 0 27.793 27.793" style="height:18px; fill:#666;">
                  <polygon points="20.972,0 5.076,15.803 10.972,15.803 6.44,27.793 22.716,11.989 16.819,11.989" />
                </svg> Instant Book
              </div> -->
              <div class="mapReviewPrice">
                <div class="mapReview">
                  <div [attr.data-bv-show]="'inline_rating'" [attr.data-bv-product-id]="record.id"
                    *ngIf="record.bv_reviews_count > 0"></div>
                </div>
                <div class="mapPrice" *ngIf="record.experience_type == 1">
                  <i class="far fa-dollar-sign pr-1"></i>{{record.exp_price | priceFormat }}
                  <span>/{{record.price_label}}</span>
                </div>
                <div class="mapPrice" *ngIf="record.experience_type == 2">
                  <span>Any price</span>
                </div>
              </div>
            </div>
          </div>
          <div class="paginationMap">
            <pagination-controls (pageChange)="pageChanged($event)"></pagination-controls>
          </div>

        </ng-container>
        <!-- <div *ngIf="resultExp && resultExp.length == 0">
          <div class="text-center">No experiences found at this location</div>
        </div> -->

      </div>
      <div class="map-view col-12 pb-3 pb-lg-0 order-0 order-lg-1  col-lg-6 px-0 pr-lg-0" id="stickyMap_2"
      *ngIf="resultExp && resultExp?.length > 0">
        <div class="searchMapLocation">
          <div *ngIf="search_with_map">
            <input type="checkbox" id="agMapSearch" [checked]="search_with_map" (click)="searchWithMap(0)" hidden />
            <label class="agSearchcheckbox" for="agMapSearch">Search as I move the map</label>
          </div>
          <div class="searchAreaMap" *ngIf="!search_with_map" (click)="searchWithMap(1)">
            <i class="fal fa-redo-alt pr-2"></i> Search this area
          </div>

        </div>
        <!-- <div *ngFor="let record of result,let i = index">
                {{record}}
            </div> -->

        <agm-map id="mapContFix" [latitude]="latitude" [longitude]="longitude" [fitBounds]="fitbounds"
          (mapReady)="mapReady($event)" [zoom]="map_zoom" (zoomChange)="zoomChange($event)">
          <agm-marker [id]="'marker_'+i" [latitude]="record.latitude" [longitude]="record.longitude"
            *ngFor="let record of resultExp,let i = index" [iconUrl]="record.map_image" [agmFitBounds]="true"
            [markerClickable]="true" (markerClick)="onMouseClick(i, infoWindow)" [zIndex]="record.zindex">
            <agm-info-window #infoWindow>
              <owl-carousel-o [options]="owlExpDetail">
                <ng-template carouselSlide [width]="250" *ngFor="let gallery of record.gallery_list" [id]="gallery.id">
                  <a (click)="exp_detail($event,record.slug,i)">
                    <div class="item">
                      <div class="mapItemOwlBack lazyload"
                        [attr.data-bg]="(gallery.image != '') ? gallery.image : '../../../assets/images/loading.gif'"
                        style="background-image: url('assets/images/loading.gif');">
                        <img class="lazyload"
                          [attr.data-src]="(gallery.image != '') ? gallery.image : '../../../assets/images/loading.gif'"
                          alt="" src="../../../../assets/images/loading.gif">
                      </div>

                    </div>
                  </a>

                </ng-template>
              </owl-carousel-o>
              <div class="mapReview mapReviewRecord" *ngIf="record.bv_reviews_count > 0">
                <div [attr.data-bv-show]="'inline_rating'" [attr.data-bv-product-id]="record.id"></div>
              </div>
              <p class="maprecordTitle" (click)="exp_detail($event,record.slug,i)">{{record.title}}</p>
              <p class="mapRecordRate" *ngIf="record.experience_type == 1">
                ${{record.regular_price | priceFormat }}<span>/{{record.price_label}}</span></p>
              <p class="mapRecordRate" *ngIf="record.experience_type == 2"><span>Any price</span></p>

            </agm-info-window>
          </agm-marker>
        </agm-map>


      </div>
    </div>
    <div class="eventList" *ngIf="view_on_map && is_booking == 2">
      <div class="row ml-0">
        <div class="col-12 order-1 order-lg-0 col-lg-6 mapListBg">
          <ng-container *ngIf="resultExp && resultExp.length > 0">
            <div class="row mapCard eventBlock_head align-items-center mx-0" (mouseenter)="map_image_enter(i)"
              (mouseleave)="map_image_out(i)"
              *ngFor="let data of resultExp | paginate: {itemsPerPage: pageSize,currentPage: page,totalItems: totalRecord } ,let i = index">
              <div class="col-12 col-md-2 px-0">
                <div class="eventDate">
                  <h5>{{data.day_name}}</h5>
                  <h6>{{data.event_date}}</h6>
                </div>
              </div>
              <div class="col-12 col-md-8 text-center text-md-left px-0">
                <div class="eventInfo">
                  <div><a [routerLink]="['/vebo-seats']"
                      [queryParams]="{'event_id': data.event_id}">{{data.event_name}}</a>
                  </div>
                  <span>{{data.event_time}} - {{data.venue_name}}, {{data.venue_location}}</span>
                </div>
              </div>
              <div class="col-12 col-md-2 px-0 text-center text-md-right">
                <div class="tkt_End">
                  <span>from</span>
                  <div class="tkt_end_day">
                    {{data.min_price!='$null' && data.min_price!='$0.00' ? data.min_price : 'NA' }} <span>(All-In
                      Price)</span>
                  </div>
                  <span>{{data.available_count}} tickets left</span>
                </div>
              </div>
            </div>
            <div class="paginationMap">
              <pagination-controls (pageChange)="pageChanged($event)"></pagination-controls>
            </div>
          </ng-container>
          <div class="empty_ticket_div" *ngIf="resultExp?.length==0 && isDataLoading == false"><span>Oops!</span>
            <p>No results found</p>
          </div>
        </div>
        <div class="map-view col-12 pb-3 pb-lg-0 order-0 order-lg-1  col-lg-6 px-0 pr-lg-0" id="stickyMap_2" 
         *ngIf="resultExp && resultExp?.length > 0">
          <div class="searchMapLocation">
            <div *ngIf="search_with_map">
              <input type="checkbox" id="agMapSearch" [checked]="search_with_map" (click)="searchWithMap(0)" hidden />
              <label class="agSearchcheckbox" for="agMapSearch">Search as I move the map</label>
            </div>
            <div class="searchAreaMap" *ngIf="!search_with_map" (click)="searchWithMap(1)">
              <i class="fal fa-redo-alt pr-2"></i> Search this area
            </div>

          </div>

          <agm-map id="mapContFix" [latitude]="latitude" [longitude]="longitude" [fitBounds]="fitbounds"
            (mapReady)="mapReady($event)" [zoom]="map_zoom" (zoomChange)="zoomChange($event)">
            <agm-marker [id]="'marker_'+i" [latitude]="record.latitude" [longitude]="record.longitude"
              *ngFor="let record of resultExp,let i = index" [iconUrl]="record.map_image" [agmFitBounds]="true"
              [markerClickable]="true" (markerClick)="onMouseClick(i, infoWindow)" [zIndex]="record.zindex">
              <agm-info-window #infoWindow>
                <ng-template *ngIf="record?.image_url != ''">
                  <a [routerLink]="['/vebo-seats']" [queryParams]="{'event_id': record.event_id}">
                    <div class="item">
                      <div class="mapItemOwlBack lazyload"
                        [attr.data-bg]="(record.image_url != '') ? record.image_url : '../../../assets/images/loading.gif'"
                        style="background-image: url('assets/images/loading.gif');">
                        <img class="lazyload"
                          [attr.data-src]="(record.image_url != '') ? record.image_url : '../../../assets/images/loading.gif'"
                          alt="" src="../../../../assets/images/loading.gif">
                      </div>
                    </div>
                  </a>
                </ng-template>
                <div class="mapWindoParant">
                  <p class="maprecordTitle"> <a [routerLink]="['/vebo-seats']"
                      [queryParams]="{'event_id': record.event_id}">{{record.event_name}}</a></p>
                  <p class="mapRecordRate">
                    {{record.min_price!='$null' && record.min_price!='$0.00' ? record.min_price : 'NA' }}<span>(All-In
                      Price)</span></p>
                </div>
              </agm-info-window>
            </agm-marker>
          </agm-map>
        </div>
      </div>
    </div>

  </div>
  <div *ngIf="isDataLoading == true" class="d-flex justify-content-center mb-2">
    <div class="spinner-border loading-spinner" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
  <div id="search_find_couple" data-offset="0" *ngIf="is_booking==1 && total_exp <1 ">
    <div class="text-center">No Record Found</div>
  </div>
  <div id="checkOutButtonWaitingBottom" style="text-align: center;" class="checkoutButtonWaiting" *ngIf="isLoading">
    <img class="loader_img_search_Bottom lazyload" alt="" src="../../../assets/images/loading.gif"
      data-src="../../../assets/images/loading.gif">
  </div>
</div>